import * as routes from '../paths';
export const paths = routes;
export const pathReplace = (path, id) => {
  return path.replace(':id', id);
};
